import styled from 'styled-components'

export const LoginBgContainer = styled.div`
  background-color: #f1f5f9;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const FormContainer = styled.form`
  background-color: #f9f9f9;
  padding: 36px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
`

export const LogoImg = styled.img`
  width: 46%;
  align-self: center;
  margin-bottom: 20px;
`

export const InputContainer = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
`

export const Label = styled.label`
  color: #1e293b;
  margin-bottom: 2px;
`

export const InputEle = styled.input`
  border: 0.5px solid #94a3b8;
  padding: 12px;
  border-radius: 3px;
  outline: none;
  color: #475569;
`

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 12px;
`

export const CheckBoxInput = styled(InputEle)``

export const CheckLabel = styled.label`
  color: #181818;
`

export const LoginBtn = styled.button`
  border-width: 0;
  background-color: #3b82f6;
  color: #ffffff;
  margin-top: 30px;
  padding: 14px;
  border-radius: 6px;
  cursor: pointer;
`

export const ErrMsg = styled.p`
  color: #ff0000;
  margin-top: 0;
`
